<form #changePasswordForm="ngForm" class="form-auth" (ngSubmit)="changeUserPassword()">
  <div class="container-fluid" id="main">
    <div class="row">
      <div class="col-md-6 col-md-offset-3" id="left">
        <div class="boxs3">
          <h2>{{pageName == 'g.reset_password' ? 'g.reset_password' : 'g.change_password' | translate}}</h2>

          <!-- Expired password info banner -->
          <div class="alert alert-warning" *ngIf="isExpired" style="margin-bottom: 15px;">
            <strong>Your password has expired.</strong> Please enter your current password and choose a new one.
          </div>

          <!-- AW-50: Password Policy Requirements -->
          <div class="alert alert-info" style="font-size: 12px; margin-bottom: 15px;">
            <strong>Password Requirements:</strong>
            <ul style="margin-bottom: 0; padding-left: 20px;">
              <li>At least 12 characters long</li>
              <li>At least one uppercase letter (A-Z)</li>
              <li>At least one lowercase letter (a-z)</li>
              <li>At least one digit (0-9)</li>
              <li>At least one special character (!@#$%^&amp;*()_+-=[]&#123;&#125;|;:,.&lt;&gt;?/~`)</li>
              <li>Cannot contain company-related words (ACT, Motive, etc.)</li>
              <li>Cannot be the same as any of your last 3 passwords</li>
            </ul>
          </div>

          <div class="form-field" *ngIf="pageName != 'reset_password'">
            <label for="oldPassword">{{'g.old_password' | translate}}</label>
            <input type="password" class="form-control" [(ngModel)]="user.oldPassword" name="oldPassword" placeholder="{{'g.old_password' | translate}}" required="true">
          </div>
          <br/>
          <div class="form-field">
            <label for="newPassword">{{'g.new_password' | translate}}</label>
            <input type="password" class="form-control" [(ngModel)]="user.newPassword" (ngModelChange)="validatePasswordPolicy()" name="newPassword" placeholder="{{'g.new_password' | translate}}" required="true">
          </div>
          <br/>
          <!-- AW-50: Client-side validation errors -->
          <div *ngIf="passwordValidationErrors.length > 0" class="alert alert-danger" style="font-size: 12px;">
            <strong>Password does not meet requirements:</strong>
            <ul style="margin-bottom: 0; padding-left: 20px;">
              <li *ngFor="let error of passwordValidationErrors">{{error}}</li>
            </ul>
          </div>
          <div class="form-field">
            <label for="confirmPassword">{{'g.confirm_password' | translate}}</label>
            <input type="password" class="form-control" [(ngModel)]="user.confirmPassword" name="confirmPassword" placeholder="{{'g.confirm_password' | translate}}" required="true">
          </div>
          <br/>
          <span class="text-danger" *ngIf="(user.confirmPassword && user.newPassword) && user.confirmPassword != user.newPassword">* {{'g.passwords_dont_match' | translate}}<br/><br/></span>
          <span class="text-danger" *ngIf="(user.confirmPassword && user.oldPassword && user.newPassword) && (user.oldPassword == user.newPassword && user.newPassword == user.confirmPassword)">* {{'g.please_choose_a_new_password' | translate}}<br/><br/></span>
          <button type="submit" class="btn btn-primary" [disabled]="changePasswordForm.invalid || (user.confirmPassword != user.newPassword) || (user.oldPassword == user.newPassword && user.newPassword == user.confirmPassword) || passwordValidationErrors.length > 0">{{'g.submit' | translate}}</button>
          <button *ngIf="pageName != 'reset_password'" type="button" class="btn btn-default" (click)="navigation.goBack(['sites-map'])">{{'g.cancel' | translate}}</button>

          <!-- Expired password: forgot old password fallback -->
          <div *ngIf="isExpired" style="margin-top: 15px;">
            <div *ngIf="!resetLinkSent">
              <a href="javascript:void(0)" (click)="sendResetLink()">Forgot your old password? Send a reset link to your email.</a>
            </div>
            <div *ngIf="resetLinkSent" class="text-success">
              A reset link has been sent to your email.
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>
